import { useEffect, useState } from "react";

const STEPS = [
  "Descargando video desde la fuente…",
  "Extrayendo frames clave…",
  "Examinando coherencia temporal…",
  "Analizando anatomía y manos…",
  "Cotejando iluminación y sombras…",
  "Buscando artefactos generativos…",
  "Generando informe final…",
];

export default function AnalysisProgress() {
  const [step, setStep] = useState(0);

  useEffect(() => {
    const id = setInterval(() => {
      setStep((s) => Math.min(s + 1, STEPS.length - 1));
    }, 1800);
    return () => clearInterval(id);
  }, []);

  const pct = Math.max(10, ((step + 1) / STEPS.length) * 100);

  return (
    <div
      className="vx-card rounded-2xl p-6 sm:p-8"
      data-testid="analysis-progress"
    >
      <div className="flex items-center justify-between mb-5">
        <div className="flex items-center gap-2.5">
          <span className="relative flex h-2.5 w-2.5">
            <span className="absolute inline-flex h-full w-full rounded-full bg-[--vx-real] opacity-60 animate-ping"></span>
            <span className="relative inline-flex rounded-full h-2.5 w-2.5 bg-[--vx-real]"></span>
          </span>
          <span className="text-xs uppercase tracking-[0.2em] text-[--vx-text-dim] font-mono">
            Análisis en curso
          </span>
        </div>
        <span className="text-xs font-mono text-[--vx-text-faint]">
          {step + 1} / {STEPS.length}
        </span>
      </div>

      <div className="h-1.5 rounded-full bg-[--vx-surface-2] overflow-hidden mb-6">
        <div
          className="h-full bg-gradient-to-r from-[--vx-text-dim] to-white transition-[width] duration-1000 ease-out"
          style={{ width: `${pct}%` }}
        />
      </div>

      <div className="space-y-2">
        {STEPS.slice(0, step + 1).map((label, i) => (
          <div
            key={i}
            className={`flex items-center gap-3 text-sm transition-opacity vx-fade-up ${
              i === step
                ? "text-white font-medium"
                : "text-[--vx-text-dim]"
            }`}
          >
            {i === step ? (
              <span className="w-3 h-3 rounded-full border-2 border-white border-t-transparent vx-spin shrink-0" />
            ) : (
              <span className="w-3 h-3 rounded-full bg-[--vx-real]/30 grid place-items-center shrink-0">
                <span className="w-1.5 h-1.5 rounded-full bg-[--vx-real]" />
              </span>
            )}
            {label}
          </div>
        ))}
      </div>
    </div>
  );
}
